export default function Marquee({ items }) {
  const doubled = [...items, ...items];
  return (
    <div data-testid="press-marquee" className="overflow-hidden relative py-8 border-y border-white/10">
      <div className="flex gap-16 marquee-track whitespace-nowrap">
        {doubled.map((item, i) => (
          <div
            key={i}
            className="font-serif-display italic text-xl md:text-2xl text-[color:var(--wk-bone-dim)] shrink-0"
          >
            {item}
            <span className="mx-8 text-[color:var(--wk-gold)]">◇</span>
          </div>
        ))}
      </div>
    </div>
  );
}
